import { isDesktop } from '../../utils/device/identifyDevice';

export default (navigationPath, prefix = '') => {
  document.body.dispatchEvent(
    new CustomEvent('dataStateChange', {
      detail: {
        action: 'jl.navTracking',
        type: `${prefix && `${prefix}|`}${isDesktop() ? 'tf' : 'sf'}`,
        navigation: navigationPath,
      },
    })
  );
};
